import React, { useMemo, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, CssBaseline, IconButton, Box } from "@mui/material";
import { AppTheme } from "./theme/AppTheme";
import Brightness4Icon from "@mui/icons-material/Brightness4";

function Root() {
  const [mode, setMode] = useState("dark");
  const theme = useMemo(() => AppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />

      {/* Theme Toggle Button at Bottom Right */}
      {/* <Box
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          zIndex: 2000,
        }}
      >
        <IconButton
          onClick={() =>
            setMode((prev) => (prev === "dark" ? "light" : "dark"))
          }
          sx={{
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.divider}`,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <Brightness4Icon />
        </IconButton>
      </Box> */}
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
